<template>
    <div>
        <div v-for="item in items"
             class="card card-dark flex-md-row mb-4 box-shadow border-0">
            <div class="card-body d-flex flex-column align-items-start">
                <h3 class="mb-0">
                    <a class="text-primary" :href="getUrl(item.slug)">{{ item.title }}</a>
                </h3>
                <div class="text-muted">
                    {{ item.date | momentFormat('DD.MM.YYYY') }}
                    <template v-if="item.author">&nbsp;|&nbsp; {{ item.author }}</template>
                </div>
                <hr/>
                <p class="card-text mb-auto">{{ item.excerpt }}</p>
                <a :href="getUrl(item.slug)" class="text-primary">
                    {{ 'read_more' | translate }}
                </a>
            </div>
            <div v-if="item.image" :style="'background-image: url('+item.image+')'"
                 class="card-img-wrapper-right flex-auto d-none d-md-block"></div>
        </div>

        <vue-pagination v-if="showPagination"
                        :items-total="itemsTotal"
                        :items-limit="itemsPerPageNum"
                        :initial-page="currentPage"
                        v-on:update:initial-page="currentPage = $event"
        ></vue-pagination>
    </div>
</template>

<script>
    import VuePagination from './Pagination'

    export default {
        props: ['itemsPerPage'],
        data() {
            // Get page number from location hash, if any.
            const foundPage = window.location.hash.match(/^#page-([0-9]+)$/);
            return {
                items: [],
                itemsTotal: 0,
                currentPage: foundPage ? parseInt(foundPage[1]) : 1
            }
        },
        computed: {
            itemsPerPageNum() {
                // Since the attribute is added by CKEditor plugin.
                // See public/vendor/backpack/ckeditor/plugins/newslist/plugin.js file.
                return parseInt(this.itemsPerPage)
            },
            showPagination() {
                return this.itemsTotal > this.itemsPerPageNum
            }
        },
        watch: {
            currentPage() {
                this.loadItems()
            }
        },
        components: {
            'vue-pagination': VuePagination
        },
        created() {
            this.loadItems()
        },
        methods: {
            loadItems() {
                axios.get(`/api/article/${this.currentPage}/${this.itemsPerPage}`)
                    .then(response => {
                        this.items = response.data.data;
                        this.itemsTotal = response.data.meta.total;
                    })
                    .catch(error => console.error(error))
            },
            getUrl(slug) {
                return window.location.origin + (window.location.pathname + '/' + slug)
                    .replace(/\/{2,}/g, '/') // Removes redundant slashes in path.
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/NewsList.vue